import SolutionPageTemplate from "./SolutionPageTemplate";

const YogaLaboralAtividadesEmGrupo = () => (
  <SolutionPageTemplate
    title="Atividades em Grupo e Rotinas de Descompressão"
    intro={[
      "A Sodalita oferece atividades coletivas voltadas ao bem-estar físico e emocional, como alongamentos guiados, yoga corporativa e práticas de regulação emocional. As ações são desenvolvidas para proporcionar pausas saudáveis durante a rotina de trabalho e auxiliar na construção de um ambiente mais equilibrado.",
      "Além de favorecer o cuidado com a saúde, essas atividades estimulam a integração e o fortalecimento das equipes.",
    ]}
    benefits={[
      "Maior equilíbrio físico e emocional no dia a dia",
      "Aumento da concentração e da clareza mental",
      "Redução do estresse e das tensões ocupacionais",
      "Melhoria da postura e prevenção de desconfortos físicos",
      "Fortalecimento da integração entre colaboradores",
      "Atividades adaptadas à rotina da empresa",
    ]}
    sectionId="yoga-laboral-atividades-grupo"
    modifier="solution-page--yoga"
  />
);

export default YogaLaboralAtividadesEmGrupo;
